// extracted by mini-css-extract-plugin
export var label = "_dz-2";
export var slideContainer = "_dz-0";
export var slider = "_dz-1";